import { createAction, createReducer } from 'redux-act';

import { CALCULATOR_FEATURE_NAME } from '@src/constants/features';

import { FULL_DEAL_FORM_AMOUNT_DEFAULT, FULL_DEAL_FORM_TERM_DEFAULT } from '../config';
import type { FullDealState, UpdateFullDealCalculatorPayload } from '../types';

export const initialState: FullDealState = {
  calculator: {
    amount: FULL_DEAL_FORM_AMOUNT_DEFAULT,
    term: FULL_DEAL_FORM_TERM_DEFAULT,
    isDirty: false,
  },
  features: {
    [CALCULATOR_FEATURE_NAME]: false,
  },
};

export const setFullDealCalculatorState = createAction<FullDealState>('fullDealCalculator/setState');

export const setFullDealCalculatorFeatures = createAction<Record<string, any>>('fullDealCalculator/setFeatures');
export const updateFullDealCalculator = createAction<UpdateFullDealCalculatorPayload>('fullDealCalculator/update');

export const fullDealReducer = createReducer<FullDealState>({}, initialState)
  .on(updateFullDealCalculator, (state, payload) => ({
    ...state,
    calculator: {
      ...state.calculator,
      ...payload,
    },
  }))
  .on(setFullDealCalculatorState, (state, payload) => ({
    calculator: {
      ...state.calculator,
      ...payload.calculator,
    },
    features: {
      ...state.features,
      ...payload.features,
    },
    branding: payload?.branding,
  }));
